<template>
    <div>
        <img src="https://smart-resource.sikegroup.com/steam-header-bg.png"/>

        <div class="course-content" style="position: relative;">
             <div class="course-content max-title" style="margin-bottom:-70px;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>
            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">点亮小星星</button>
                </div>
            </div>
            <ul class="list-text">
                <li>
                    <div>是一款训练孩子空间想象力的游戏。空间想象能力是几何学习的核心，它是一系列空间能力的总和，主要包括感受、辨别、记忆和改变物体的空间关系来处理空间问题的能力。</div>
                </li>
            </ul>
            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                   <img style="margin-right:60px" src="@/assets/imgs/course/thinking-1.png" alt="">
                </li>
                <li>
                    <img style="margin-right:60px" src="@/assets/imgs/course/thinking-2.png" alt="">
                </li>
            </ul>
            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">中国元素</button>
                </div>
            </div>
            <ul class="list-text" style="display: flex;justify-content: space-between;">
                <li>
                    <div>是一款提高孩子逻辑思维能力的解谜游戏。孩子通过思考与观察，发现行、列、宫之间隐含的规律，可以发展自己的数理逻辑和推理能力、表达能力和沟通能力、自控力以及自主思考的能力。</div>
                </li>
                <li>
                    <img style="margin-left:80px;" src="@/assets/imgs/course/thinking-3.png" alt="">
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">水晶探险</button>
                </div>
            </div>
            <ul class="list-text" style="display: flex;justify-content: space-between;">
                <li>
                    <div>是一款培养儿童编程思维的编程启蒙游戏。编程思维是一种特别的逻辑思维方式，是人工智能时代孩子必备的一种基础能力。</div>
                </li>
                <li>
                    <img style="margin-left:80px;" src="@/assets/imgs/course/thinking-4.png" alt="">
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn" style="width:250px;">认识函数</button>
                </div>
            </div>
            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <div>帮助孩子了解函数的基本概念和作用，识别函数卡片，并训练孩子进行简单的函数定义和调用。</div>
                </li>
            </ul>
            <ul class="list-text" style="display: flex;justify-content: space-between;">
                <li style="width:100%;border-radius:0.6rem;background:#f6f6f6;">
                    <div style="margin:1.1rem 7%;">卡片使用参考：</div>
                    <img src="@/assets/imgs/course/thinking-6.png" style="width:86%;margin-left:7%;">
                </li>
                <li>
                    <img style="margin-left:60px;" src="@/assets/imgs/course/thinking-5.png" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name:'thinking',
    data(){
        return{

        }
    }
}
</script>
<style lang="less" scoped>

    .content-item{
        border-top: 1px solid #F8B300;
    }
    .page-btn{
        background: #F8B300;
    }
    .max-title{
        color: #F8B300;
        border-bottom: 1px solid #F8B300;
    }
    .list-text{
        margin: 30px 0;
        color: #6A6767;
        font-size: 16px;
        font-family: Light;
        li{
            img{
                margin-right: 15px;
            }
        }
    }
</style>
